import React, { Component } from "react"
import PropTypes from "prop-types"
import { Button } from "react-bootstrap"
import { browserHistory } from "react-router"

import { Row, Col } from "react-bootstrap"
import moment from "moment";
import FontAwesome from "react-fontawesome"
import Authenticated from "../../../lib/Authenticated"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import { blockingFetchService } from "../../../lib/blockingFetch"
import SimpleCardRow from "../../fragments/SimpleCardRow"
import FixRecordingInFineract from "../../fragments/FixRecordingInFineract"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"

class GLClosureCard extends Component {

  authenticated = new Authenticated()
  isAdminOrAccountant = this.authenticated.isAdmin() || this.authenticated.isAccountant()

  state = {
    runningFix: false,
    fixDone: false,
    error: null,
  }

  resubmitInFineract = id => {

    this.setState({
      runningFix: true,
      fixDone: false,
      error: null,
    })

    blockingFetchService(
      accessToken => apiServerApi.triggerGLClosureRecording(accessToken, id),
      _ => this.setState({ fixDone: true }),
      error => this.setState({ error: error.text }),
      _ => this.setState({ runningFix: false })
    )
  }

  checkRecording = item => {

    const { fixDone, runningFix, error } = this.state
    if(item.fineractId !== 0 || fixDone || !this.isAdminOrAccountant) return null
    return <FixRecordingInFineract
      running={ runningFix } error={ error }
      onClick={() => this.resubmitInFineract(item.id)}
    />
  }

  renderButtonToolbar = id => {

    if(!this.isAdminOrAccountant) return null
    return (
      <div className='align-right'>
        <Button bsStyle="primary" onClick={() => browserHistory.push(`/glclosures/${id}/update`)}>
          <FontAwesome name='pencil' /> Update
        </Button> &nbsp;

        <Button bsStyle="success" onClick={() => browserHistory.push('/glclosures/create')}>
          <FontAwesome name='plus-circle' /> New Closure
        </Button>
      </div>
    )
  }

  showItem = item => {

    if(!item) return null
    const { id, closingDate, comments, createdOn } = item

    return (
      <Col md={8} className='detail-content'>

        { this.checkRecording(item) }

        <h2 className="blue">{ moment(closingDate).format('LL') }</h2>

        <SimpleCardRow name='Closing Date' value={ closingDate } />
        <SimpleCardRow name='Comments' value={ comments ? comments : '-' } />
        <SimpleCardRow name='Created On' value={ createdOn ? moment(createdOn).format('lll') : '' }
          className='gray font-size-13' />

        { this.renderButtonToolbar(id) }

      </Col>
    )
  }

  render() {
    const { glClosure } = this.props
    const data = [{ url: '/accounting', title: 'Accounting' }, { url: '/glclosures', title: 'GL closures' }]

    return (
      <div>
        <CustomBreadCrumb activeText={ glClosure.closingDate } data={ data } />
        <Row>
          <Col md={4} className="align-center">
            <FontAwesome name="folder" size="3x" className="detail-icon" />
          </Col>

          { this.showItem(glClosure) }
        </Row>
      </div>
    )
  }
}

GLClosureCard.propTypes = {
  glClosure: PropTypes.object.isRequired,
}

export default GLClosureCard



// WEBPACK FOOTER //
// ./src/components/Accounting/GLClosures/Card.js